/** Same-origin BroadcastChannel name for coordinating auth across browser tabs. */
export const AUTH_BROADCAST_CHANNEL_NAME = "institute-portal-auth";
